<template>
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.PaymentFail.msg1') }}</div>
        <div class="ft-error">{{ $t('Modal.PaymentFail.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.PaymentFail.msg3') }}</div>
      </div>
      <div class="layer__body">
        <div class="info-area">
          <span class="img-error red"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'paymentFail',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {},
  props: {},
  methods: {},
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
